import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/logo_only.svg'


const _hoisted_1 = { class: "mt-12" }
const _hoisted_2 = { class: "text-gray-600 body-font bg-white" }
const _hoisted_3 = { class: "container py-12 mx-auto flex md:items-center lg:items-start w-full" }
const _hoisted_4 = { class: "w-64 flex-shrink-0 md:mx-0 mx-auto text-center md:text-left" }
const _hoisted_5 = { class: "flex title-font font-medium items-center md:justify-start justify-center" }
const _hoisted_6 = { class: "ml-3 text-xl" }
const _hoisted_7 = { class: "mt-2 text-sm" }
const _hoisted_8 = { class: "flex-grow flex flex-wrap md:pl-20 -mb-10 md:mt-0 mt-10 md:text-left text-center" }
const _hoisted_9 = {
  key: 0,
  class: "lg:w-1/4 md:w-1/2 w-full px-4"
}
const _hoisted_10 = { class: "font-semibold tracking-widest text-md mb-3" }
const _hoisted_11 = { class: "list-none mb-10" }
const _hoisted_12 = { class: "lg:w-3/4 md:w-1/2 w-full px-4" }
const _hoisted_13 = { class: "tracking-widest font-semibold" }
const _hoisted_14 = { class: "mt-5 flex w-full" }
const _hoisted_15 = { class: "lg:w-2/4 md:w-3/4" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "bg-red-500" }
const _hoisted_18 = { class: "container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row" }
const _hoisted_19 = { class: "text-white text-sm text-center sm:text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("footer", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              class: "w-10 h-10 p-2 bg-white rounded-full",
              src: _imports_0,
              alt: "avored e commerce"
            }, null, -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('avored')), 1)
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t('avored_tagline')), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (!_ctx.fetching)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.t('categories')), 1),
                _createElementVNode("nav", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.allCategory, (category, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `footer-category-link-${index}`
                    }, [
                      _createVNode(_component_router_link, {
                        class: "hover:text-red-300",
                        to: {name: 'category', params: {slug: category.slug}}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(category.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.t('signup_for_our_newsletter')), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subscriberEmail) = $event)),
                  placeholder: _ctx.t('enter_your_email_address'),
                  type: "email",
                  class: "w-full px-4 py-3 ring-gray-300 ring-1 focus:ring-red-500 focus:outline-none rounded shadow-sm appearance-none text-gray-700"
                }, null, 8, _hoisted_16), [
                  [_vModelText, _ctx.subscriberEmail]
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.notifyMeOnClick && _ctx.notifyMeOnClick(...args))),
                class: "ml-3 px-4 py-3 ring-1 ring-red-500 shadow-lg text-white font-semibold bg-red-500 rounded-md"
              }, _toDisplayString(_ctx.t('notify_me')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("p", _hoisted_19, [
            _createTextVNode(" © " + _toDisplayString(_ctx.year) + " — ", 1),
            _cache[3] || (_cache[3] = _createElementVNode("a", {
              href: "https://www.avored.com/",
              rel: "noopener noreferrer",
              class: "ml-1",
              target: "_blank"
            }, "@AvoRed E commerce", -1))
          ]),
          _cache[4] || (_cache[4] = _createStaticVNode("<span class=\"inline-flex sm:ml-auto sm:mt-0 mt-2 justify-center sm:justify-start\"><a class=\"text-gray-200\" href=\"https://www.facebook.com/avored\" target=\"_blank\"><svg fill=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"w-5 h-5\" viewBox=\"0 0 24 24\"><path d=\"M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z\"></path></svg></a><a class=\"ml-3 text-gray-200\" href=\"https://twitter.com/avoredecommerce\" target=\"_blank\"><svg fill=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"w-5 h-5\" viewBox=\"0 0 24 24\"><path d=\"M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z\"></path></svg></a><a class=\"ml-3 text-gray-200\" href=\"https://linkedin.com/company/avored-e-commerce\" target=\"_blank\"><svg fill=\"currentColor\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0\" class=\"w-5 h-5\" viewBox=\"0 0 24 24\"><path stroke=\"none\" d=\"M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z\"></path><circle cx=\"4\" cy=\"4\" r=\"2\" stroke=\"none\"></circle></svg></a></span>", 1))
        ])
      ])
    ])
  ]))
}